import ApolloLinkExecutor from "../apollo/ApolloLinkExecutor";
import { getCache } from "../apollo/getCache";
import MemoryCache from "../cache/MemoryCache";
import InteroperabilityLayer from "../interoperability/InteroperabilityLayer";
import createApolloLink from "../links/createApolloLink";
import ErrorCache from "../observable/ErrorCache";
import ObservableStore from "../observable/ObservableStore";
import ResultStore from "../observable/ResultStore";
import PollingClock from "../polling/PollingClock";
import { reportRuntimeError } from "../telemetry/internalReporting";
export const MAX_STORE_SIZE = 10000;
// Keep it as a module singleton to avoid creating a new clock for each DataClient.
const pollingClock = new PollingClock();
export default function createGraphQlDataClient(graphQlConfig, fetchFunction, observabilityFns) {
    if (!graphQlConfig) {
        return undefined;
    }
    try {
        const { staleTime, schemas } = graphQlConfig;
        const link = createApolloLink(schemas, observabilityFns);
        const errorCache = new ErrorCache();
        const memoryCache = new MemoryCache(observabilityFns, getCache(schemas, graphQlConfig.sharedCache, graphQlConfig.sharedCacheId));
        const resultStore = new ResultStore(memoryCache, errorCache, staleTime);
        const apolloLinkExecutor = new ApolloLinkExecutor(link, fetchFunction);
        const observableStore = new ObservableStore(observabilityFns, apolloLinkExecutor, resultStore, memoryCache, pollingClock);
        const interoperabilityLayer = new InteroperabilityLayer(resultStore);
        return {
            memoryCache,
            observableStore,
            resultStore,
            apolloLinkExecutor,
            interoperabilityLayer,
            pollingClock
        };
    } catch (error) {
        // This'll ensure that errors in the revamp layer do not crash the entire application.
        // When revamp is rolled out, we'll re-throw the error, as it would be a catastrophic error warranting a full app breakage.
        reportRuntimeError(observabilityFns, error, 'GraphQL client initialization');
        return undefined;
    }
}

//# sourceMappingURL=createGraphQlDataClient.js.map